export default [
  {
    header: 'Menu',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Empresas',
        route: 'list-companies',
        icon: 'BriefcaseIcon',
      },
      {
        title: 'Unidades',
        route: 'list-units',
        icon: 'MapPinIcon',
      },
      {
        title: 'Usuários',
        route: 'list-users',
        icon: 'UsersIcon',
      },
      {
        title: 'Grupos',
        route: 'list-groups',
        icon: 'UsersIcon',
      },
      {
        title: 'Checklists',
        route: 'list-checklists',
        icon: 'LinkIcon',
      },
    ],
  },
]
